module.exports = __webpack_public_path__ + "static/media/jack_and_the_beanstalk.netent.09a87e63.jpeg";